import { Box, LinearProgress, Typography } from "@mui/material";
import { Card } from "src/design/Card";
import { useTranslation } from "react-i18next";
import { PartySizeEntry } from "src/data/admin/types/analytics";
import { colorTextSecondary } from "src/design/tokens";
import { AnalyticsCardHeader } from "./AnalyticsCardHeader";

const BAR_COLORS = ["#1abc9c", "#2563EB", "#7C3AED", "#F59E0B"];

interface Props {
  data: PartySizeEntry[];
}

export const PartySizeDistribution = ({ data }: Props) => {
  const { t } = useTranslation();

  return (
    <Card sx={{ flexDirection: "column", gap: 0, height: '100%' }}>
      <Box sx={{ height: "15%" }}>
        <AnalyticsCardHeader
          title={t("analytics.partySizeDistribution.title")}
          subtitle={t("analytics.partySizeDistribution.subtitle")}
          subtitleSpacing={6}
        />
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%", height: "85%", justifyContent: 'space-evenly' }}>
        {data.map((entry, index) => (
          <Box key={entry.label}>
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
              <Typography sx={{ fontSize: "0.8rem", color: colorTextSecondary }}>
                {entry.label}
              </Typography>
              <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: colorTextSecondary }}>
                {entry.percentage}%
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={entry.percentage}
              sx={{
                height: 8,
                borderRadius: 4,
                backgroundColor: "#F3F4F6",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: BAR_COLORS[index % BAR_COLORS.length],
                  borderRadius: 4,
                },
              }}
            />
          </Box>
        ))}
      </Box>
    </Card>
  );
};
